import { render } from "./BlockItem.vue?vue&type=template&id=7d865e15&scoped=true"
import script from "./BlockItem.vue?vue&type=script&lang=js"
export * from "./BlockItem.vue?vue&type=script&lang=js"

import "./BlockItem.vue?vue&type=style&index=0&id=7d865e15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d865e15"]])

export default __exports__